import React from 'react'
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import ConsultationAccordion from '../../elements/accordion/ConsultationAccordion';
import Separator from '../../elements/separator/Separator';
import RegistrationForm from '../../components/form/RegistrationForm';
import LoginForm from '../../components/form/LoginForm';



const Login = () => {
    return (
        <>
            <SEO title="Login" />
            <main className="page-wrapper">
                <HeaderTopBar />
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                {/* This is the Service Categories Area */}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <LoginForm />
                    </div>
                </div>






                <FooterOne />
                <Copyright />
            </main>

        </>
    )
}

export default Login
